import type { AppProps } from 'next/app';
import { Open_Sans } from 'next/font/google';

import { RouteHandlerReturn } from 'src/types/model';

import '../styles/global/global.scss';

const openSans = Open_Sans({
  weight: ['300', '400', '500', '600', '700', '800'],
  subsets: ['latin'],
});

function App({ Component, pageProps }: AppProps<RouteHandlerReturn>): JSX.Element {
  return (
    <>
      <style jsx global>{`
        html {
          font-family: ${openSans.style.fontFamily};
        }
      `}</style>
      <Component {...pageProps} />
    </>
  );
}

export default App;
